export default {"src":"/_next/static/media/liveScore.f3790212.svg","height":20,"width":121,"blurWidth":0,"blurHeight":0};